import React from 'react';
import ReactDOM from 'react-dom/client';
import { initSentry, Sentry } from './utils/sentry';
import './i18n'; // Initialize i18n before App
import App from './App';
import { ToastProvider, UpdateNotification } from './components/common';
import './utils/chunkErrorHandler'; // Initialize chunk error handler

initSentry();

function ErrorFallback() {
  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', maxWidth: 480, margin: '64px auto', textAlign: 'center' }}>
      <h1 style={{ fontSize: 18, marginBottom: 8 }}>Something went wrong.</h1>
      <p style={{ fontSize: 14, color: '#555', marginBottom: 16 }}>
        We've been notified. Please refresh the page to continue.
      </p>
      <button
        onClick={() => window.location.reload()}
        style={{ padding: '8px 16px', cursor: 'pointer' }}
      >
        Refresh
      </button>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
    <ToastProvider>
      <UpdateNotification />
      <App />
    </ToastProvider>
  </Sentry.ErrorBoundary>
);
